<div class="maintenance-container">
	<div class="maintenance-content">
		<div class="maintenance-icon">
			<i class="fas fa-tools"></i>
		</div>
		<h1>MAINTENANCE IN PROGRESS</h1>
		<p>The site is temporarily unavailable.</p>
		<p>You will be redirected automatically when the maintenance is complete.</p>
		<div class="maintenance-spinner">
			<i class="fas fa-spinner fa-spin"></i>
			<span>Checking maintenance progress...</span>
		</div>
	</div>
</div>